import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import noop from 'lodash/noop';
import PropTypes from 'prop-types';
import range from 'lodash/range';

import Form from '../Form';
import messages from './messages';
import './styles.css';

const months = [
  { text: 'January', value: 1 },
  { text: 'February', value: 2 },
  { text: 'March', value: 3 },
  { text: 'April', value: 4 },
  { text: 'May', value: 5 },
  { text: 'June', value: 6 },
  { text: 'July', value: 7 },
  { text: 'August', value: 8 },
  { text: 'September', value: 9 },
  { text: 'October', value: 10 },
  { text: 'November', value: 11 },
  { text: 'December', value: 12 },
];

export function daysInMonth(month) {
  return new Date(new Date().getFullYear(), month, 0).getDate();
}

export function getRangeOptions(month) {
  const end = daysInMonth(month) + 1;
  return range(1, end).map((index) => ({
    text: index,
    value: index,
  }));
}

const MonthDayField = ({ onChange, initialValue, disabled }) => {
  const { month, day } = initialValue;
  const [numberOfDays, updateDays] = useState(getRangeOptions(1));
  const [currentMonth, setMonth] = useState(Number(month));
  const [currentDay, setDay] = useState(Number(day));

  return (
    <div styleName="container">
      <Form.Select
        label={<FormattedMessage {...messages.month} />}
        options={months}
        value={currentMonth}
        fluid
        disabled={disabled}
        data-cy="Premium-Hem-Month-Dropdown"
        aria-label="Month"
        styleName="field-month"
        onChange={(e, { value }) => {
          updateDays(getRangeOptions(value));
          setMonth(value);
          onChange('month', { month: value, day: currentDay });
        }}
      />
      <Form.Select
        label={<FormattedMessage {...messages.day} />}
        options={numberOfDays}
        value={currentDay}
        fluid
        disabled={disabled}
        data-cy="Premium-Hem-Day-Dropdown"
        aria-label="Days in month"
        styleName="field-day"
        onChange={(e, { value }) => {
          setDay(value);
          onChange('day', { month: currentMonth, day: value });
        }}
      />
    </div>
  );
};

MonthDayField.propTypes = {
  onChange: PropTypes.func,
  initialValue: PropTypes.object,
  disabled: PropTypes.bool,
};

MonthDayField.defaultProps = {
  initialValue: {
    month: 1,
    day: 1,
  },
  onChange: noop,
};

export default MonthDayField;
